import * as echarts from "echarts";
import chinaMapData from '@/utils/data/china.json'
echarts.registerMap('china', chinaMapData)


function echartsFn(el) {
  const instance = echarts.init(el);
  const setData = (options) => {
    instance.setOption(options);
  };
  window.addEventListener("resize", () => {
    instance.resize();
  });
  return { instance, setData };
}

export default echartsFn;
